import PropTypes from 'prop-types';

export const HeaderDefaultProps = {
  noBottomHeader: false,
};

export const HeaderPropTypes = {
  noBottomHeader: PropTypes.bool,
};
